import React from 'react'

export default function YourPost({ item }) {
    return (
        <>
            {item?.is_mine == 1 && (
                <p className="post-applied  post-ap your-postbtn">
                    Your post
                </p>
            )}
        </>
    )
}
